import React, {useEffect, useRef} from 'react';
import { StyledVideoScrollAlone } from './StyledVideoScrollAlone';
import { gsap } from "gsap";

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const VideoScrollAlone = ({ video, poster, idScroll}) => {
  const videoHolderRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {

    var videoEl = videoRef.current.querySelector('video');
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    ScrollTrigger.create({
      trigger: videoHolderRef.current,
      start: 'top center',
      end: 'top -=50%',
      scrub:  0.1,
      id: idScroll,
      onEnter: () => {
        
        gsap.to(videoRef.current, { marginRight: 0, marginLeft: 0, onComplete: () =>{
          videoEl.play()
        }})
      },
      onLeave: () => {
        var leaveRight = window.innerWidth <= 768 ? '24px' : window.innerWidth <= 1439 ? '40px' : '64px';
        var leaveLeft = window.innerWidth <= 768 ? '24px' : window.innerWidth <= 1439 ? '40px' : '64px';

        gsap.to(videoRef.current,{ marginRight: leaveRight, marginLeft: leaveLeft, top: '0px', y: '0',  onComplete: () =>{
          videoEl.pause()
        }})
      },
      onEnterBack: () => {
        gsap.to(videoRef.current, { marginRight: 0, marginLeft: 0, onComplete: () =>{
          videoEl.play()
        }})
      },
      onLeaveBack: () => {
        var leaveRight = window.innerWidth <= 768 ? '24px' : window.innerWidth <= 1439 ? '40px' : '64px';
        var leaveLeft = window.innerWidth <= 768 ? '24px' : window.innerWidth <= 1439 ? '40px' : '64px';

        gsap.to(videoRef.current,{ marginRight: leaveRight, marginLeft: leaveLeft,top: '0px', y: '0', onComplete: () =>{
          videoEl.pause()
        }})
      }
    })
    

    return () => {
      ScrollTrigger.getById(idScroll).kill();
    }
  }, [])

  return (
    <React.Fragment>
      {
          <StyledVideoScrollAlone
          ref={videoHolderRef}
          >
            <div className="video--height">
              <div className="video--wrap" ref={videoRef}>
                <video loop muted playsInline preload="metadata" controls>
                  <source src={video} type="video/mp4"></source>
                </video>
              </div>    
            </div>        
          </StyledVideoScrollAlone>
          
      }
    </React.Fragment>
  );
};

export default VideoScrollAlone;
